<template>
  <form @submit.prevent="update" novalidate autocomplete="off">
    <div class="columns">
      <div class="column is-one-fifth">
        <p class="has-text-weight-bold is-size-6 mb-sm">Webhook Notifications</p>
        <p class="has-text-grey is-size-7">
          Subscribe to push notifications to receive real-time alerts related to webhook events.
        </p>
      </div>
      <div class="column">
        <div v-if="!isLoading">
          <!-- Supplier Notifications -->
          <div v-if="context.isSupplier()">
            <div v-for="notification in supplierNotifications" :key="notification.action" class="mb-md">
              <PushNotification
                :notifications="pushNotifications"
                :action="notification.action"
                :title="notification.title"
                :text="notification.text" />
            </div>
          </div>
          <!-- Merchant Notifications -->
          <div v-else>
            <div v-for="notification in merchantNotifications" :key="notification.action" class="mb-md">
              <PushNotification
                :notifications="pushNotifications"
                :action="notification.action"
                :title="notification.title"
                :text="notification.text" />
            </div>
          </div>
        </div>
        <!-- while loading -->
        <div v-else>
          <div v-for="index in 2" :key="index">
            <div class="has-background-white pa-md rounded-lg mb-sm">
              <div class="mb-md">
                <b-skeleton width="25%" :animated="true"></b-skeleton>
                <b-skeleton width="75%" :animated="true"></b-skeleton>
              </div>
              <b-skeleton width="50%" height="30" :animated="true"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import PushNotification from './PushNotification'

export default {
  components: {
    PushNotification
  },
  computed: {
    ...mapGetters(['context']),
    merchantNotifications () {
      const notifications = []
      this.availableNotifications.forEach(notification => {
        if (notification.context.includes('retailer')) {
          notifications.push(notification)
        }
      })
      return notifications
    },
    supplierNotifications () {
      const notifications = []
      this.availableNotifications.forEach(notification => {
        if (notification.context.includes('supplier')) {
          notifications.push(notification)
        }
      })
      return notifications
    }
  },
  data () {
    return {
      availableNotifications: [{
        action: 'Webhook Failed',
        title: 'Webhook Failed to Deliver',
        text: 'If you want to be notified when a webhook for an event fails to deliver after 10 retries, the platform will send a notification to the address or distribution list specified below.',
        context: ['supplier', 'retailer']
      }, {
        action: 'Webhook Disabled',
        title: 'Webhook Disabled After Failed Attempts',
        text: 'If you want to be notified when a webhook for an event is automatically disabled after 10 failed delivery attempts, the platform will send a notification to the address or distribution list specified below.',
        context: ['supplier', 'retailer']
      }]
    }
  },
  methods: {

  },
  mounted () {

  },
  props: {
    pushNotifications: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
